import type { v2, ChangeDefinitionInCreation } from '@sap/ux-specification-types';
import { ControlType, PropertyName } from '@sap/ux-specification-types';
import { syncRule, validity } from '../../../common/decoration/decorators';
import { getChartSettingPathV2 } from '../../application';

export const getSmartChartControlId = (baseId: string): string => {
    return baseId + PropertyName.chart;
};

export class ChartSettings implements v2.ChartSettings {
    @syncRule({
        flex: {
            controlId: getSmartChartControlId,
            controlType: (): ControlType => ControlType.SmartChart
        }
    })
    showLegendButton?: boolean;

    @syncRule({
        flex: {
            controlId: getSmartChartControlId,
            controlType: (): ControlType => ControlType.SmartChart
        }
    })
    showDownloadButton?: boolean;

    @syncRule({
        flex: {
            controlId: getSmartChartControlId,
            controlType: (): ControlType => ControlType.SmartChart
        }
    })
    showChartTypeSelectionButton?: boolean;

    @syncRule({
        flex: {
            controlId: getSmartChartControlId,
            controlType: (): ControlType => ControlType.SmartChart,
            exportFlexValue: (flexChange: ChangeDefinitionInCreation, configObject: object, key: string): void => {
                flexChange.content.newValue = configObject[key].join();
            },
            importFlexValue: (flexChange: ChangeDefinitionInCreation, configObject: object, key: string): void => {
                flexChange.content['newValue'] = flexChange.content['newValue'] as string;
                configObject[key] = flexChange.content['newValue'].split(',') as v2.ChartType[];
            }
        }
    })
    ignoredChartTypes?: v2.ChartType[];

    @syncRule({
        manifest: {
            path: (pageKeys): string => getChartSettingPathV2(pageKeys)
        }
    })
    @validity({
        since: '1.81.0'
    })
    showDataLabel: boolean;
}
